export const PAGINATION_MAPPER = {
  "0": {
    "0": [] as number[],
  },
  "1": {
    "1": [1],
  },
  "2": {
    "1": [1, 2],
    "2": [1, 2],
  },
  "3": {
    "1": [1, 2, 3],
    "2": [1, 2, 3],
    "3": [1, 2, 3],
  },
  "4": {
    "1": [1, 2, 3, 4],
    "2": [1, 2, 3, 4],
    "3": [1, 2, 3, 4],
    "4": [1, 2, 3, 4],
  },
  "5": {
    "1": [1, 2, 3, 4, 5],
    "2": [1, 2, 3, 4, 5],
    "3": [1, 2, 3, 4, 5],
    "4": [1, 2, 3, 4, 5],
    "5": [1, 2, 3, 4, 5],
  },
  "6": {
    "1": [1, 2, 3, 4, 5, 6],
    "2": [1, 2, 3, 4, 5, 6],
    "3": [1, 2, 3, 4, 5, 6],
    "4": [1, 2, 3, 4, 5, 6],
    "5": [1, 2, 3, 4, 5, 6],
    "6": [1, 2, 3, 4, 5, 6],
  },
  "7": {
    "1": [1, 2, 3, 4, 5, -1, 7],
    "2": [1, 2, 3, 4, 5, -1, 7],
    "3": [1, 2, 3, 4, 5, -1, 7],
    "4": [1, -1, 3, 4, 5, -1, 7],
    "5": [1, -1, 3, 4, 5, 6, 7],
    "6": [1, -1, 3, 4, 5, 6, 7],
    "7": [1, -1, 3, 4, 5, 6, 7],
  },
  "8": {
    "1": [1, 2, 3, 4, 5, -1, 8],
    "2": [1, 2, 3, 4, 5, -1, 8],
    "3": [1, 2, 3, 4, 5, -1, 8],
    "4": [1, -1, 3, 4, 5, -1, 8],
    "5": [1, -1, 4, 5, 6, -1, 8],
    "6": [1, -1, 4, 5, 6, 7, 8],
    "7": [1, -1, 4, 5, 6, 7, 8],
    "8": [1, -1, 4, 5, 6, 7, 8],
  },
  "9": {
    "1": [1, 2, 3, 4, 5, -1, 9],
    "2": [1, 2, 3, 4, 5, -1, 9],
    "3": [1, 2, 3, 4, 5, -1, 9],
    "4": [1, -1, 3, 4, 5, -1, 9],
    "5": [1, -1, 4, 5, 6, -1, 9],
    "6": [1, -1, 5, 6, 7, -1, 9],
    "7": [1, -1, 5, 6, 7, 8, 9],
    "8": [1, -1, 5, 6, 7, 8, 9],
    "9": [1, -1, 5, 6, 7, 8, 9],
  },
  "10": {
    "1": [1, 2, 3, 4, 5, -1, 10],
    "2": [1, 2, 3, 4, 5, -1, 10],
    "3": [1, 2, 3, 4, 5, -1, 10],
    "4": [1, -1, 3, 4, 5, -1, 10],
    "5": [1, -1, 4, 5, 6, -1, 10],
    "6": [1, -1, 5, 6, 7, -1, 10],
    "7": [1, -1, 6, 7, 8, -1, 10],
    "8": [1, -1, 6, 7, 8, 9, 10],
    "9": [1, -1, 6, 7, 8, 9, 10],
    "10": [1, -1, 6, 7, 8, 9, 10],
  },
  "11": {
    "1": [1, 2, 3, 4, 5, -1, 11],
    "2": [1, 2, 3, 4, 5, -1, 11],
    "3": [1, 2, 3, 4, 5, -1, 11],
    "4": [1, -1, 3, 4, 5, -1, 11],
    "5": [1, -1, 4, 5, 6, -1, 11],
    "6": [1, -1, 5, 6, 7, -1, 11],
    "7": [1, -1, 6, 7, 8, -1, 11],
    "8": [1, -1, 7, 8, 9, -1, 11],
    "9": [1, -1, 7, 8, 9, 10, 11],
    "10": [1, -1, 7, 8, 9, 10, 11],
    "11": [1, -1, 7, 8, 9, 10, 11],
  },
  "12": {
    "1": [1, 2, 3, 4, 5, -1, 12],
    "2": [1, 2, 3, 4, 5, -1, 12],
    "3": [1, 2, 3, 4, 5, -1, 12],
    "4": [1, -1, 3, 4, 5, -1, 12],
    "5": [1, -1, 4, 5, 6, -1, 12],
    "6": [1, -1, 5, 6, 7, -1, 12],
    "7": [1, -1, 6, 7, 8, -1, 12],
    "8": [1, -1, 7, 8, 9, -1, 12],
    "9": [1, -1, 8, 9, 10, -1, 12],
    "10": [1, -1, 8, 9, 10, 11, 12],
    "11": [1, -1, 8, 9, 10, 11, 12],
    "12": [1, -1, 8, 9, 10, 11, 12],
  },
  "13": {
    "1": [1, 2, 3, 4, 5, -1, 13],
    "2": [1, 2, 3, 4, 5, -1, 13],
    "3": [1, 2, 3, 4, 5, -1, 13],
    "4": [1, -1, 3, 4, 5, -1, 13],
    "5": [1, -1, 4, 5, 6, -1, 13],
    "6": [1, -1, 5, 6, 7, -1, 13],
    "7": [1, -1, 6, 7, 8, -1, 13],
    "8": [1, -1, 7, 8, 9, -1, 13],
    "9": [1, -1, 8, 9, 10, -1, 13],
    "10": [1, -1, 9, 10, 11, -1, 13],
    "11": [1, -1, 9, 10, 11, 12, 13],
    "12": [1, -1, 9, 10, 11, 12, 13],
    "13": [1, -1, 9, 10, 11, 12, 13],
  },
  "14": {
    "1": [1, 2, 3, 4, 5, -1, 14],
    "2": [1, 2, 3, 4, 5, -1, 14],
    "3": [1, 2, 3, 4, 5, -1, 14],
    "4": [1, -1, 3, 4, 5, -1, 14],
    "5": [1, -1, 4, 5, 6, -1, 14],
    "6": [1, -1, 5, 6, 7, -1, 14],
    "7": [1, -1, 6, 7, 8, -1, 14],
    "8": [1, -1, 7, 8, 9, -1, 14],
    "9": [1, -1, 8, 9, 10, -1, 14],
    "10": [1, -1, 9, 10, 11, -1, 14],
    "11": [1, -1, 10, 11, 12, -1, 14],
    "12": [1, -1, 10, 11, 12, 13, 14],
    "13": [1, -1, 10, 11, 12, 13, 14],
    "14": [1, -1, 10, 11, 12, 13, 14],
  },
  "15": {
    "1": [1, 2, 3, 4, 5, -1, 15],
    "2": [1, 2, 3, 4, 5, -1, 15],
    "3": [1, 2, 3, 4, 5, -1, 15],
    "4": [1, -1, 3, 4, 5, -1, 15],
    "5": [1, -1, 4, 5, 6, -1, 15],
    "6": [1, -1, 5, 6, 7, -1, 15],
    "7": [1, -1, 6, 7, 8, -1, 15],
    "8": [1, -1, 7, 8, 9, -1, 15],
    "9": [1, -1, 8, 9, 10, -1, 15],
    "10": [1, -1, 9, 10, 11, -1, 15],
    "11": [1, -1, 10, 11, 12, -1, 15],
    "12": [1, -1, 11, 12, 13, -1, 15],
    "13": [1, -1, 11, 12, 13, 14, 15],
    "14": [1, -1, 11, 12, 13, 14, 15],
    "15": [1, -1, 11, 12, 13, 14, 15],
  },
}

/**
 * Generates pagination mapping for given total number of pages
 * @param totalPages Total number of pages
 * @returns Object containing pagination mapping similar to PAGINATION_MAPPER
 */
export function generatePaginationMapping(
  totalPages: number,
): Record<string, Record<string, number[]>> {
  if (totalPages <= 0) return { "0": { "0": [] } }

  const result: Record<string, Record<string, number[]>> = {}

  // Create the outer object for total pages
  result[totalPages.toString()] = {}

  // For each current page
  for (let currentPage = 1; currentPage <= totalPages; currentPage++) {
    let pages: number[] = []

    if (totalPages <= 6) {
      // Show all pages if total pages are 6 or less
      pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    } else {
      // Always show first page
      pages.push(1)

      if (currentPage <= 3) {
        // First 3 pages: show first 5 pages + ellipsis + last page
        pages.push(2, 3, 4, 5, -1, totalPages)
      } else if (currentPage > totalPages - 3) {
        // Last 3 pages: show first page + ellipsis + last 5 pages
        pages.push(
          -1,
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        )
      } else {
        // Middle pages: show first page + ellipsis + current-1, current, current+1 + ellipsis + last page
        pages.push(
          -1,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          -1,
          totalPages,
        )
      }
    }

    result[totalPages.toString()][currentPage.toString()] = pages
  }

  return result
}
